export const privacyEn = `
## Pivacy Policy
At Wiser, we are committed to protecting the privacy and security of our users' information. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website, use our application, or engage with our services, including any other media form, media channel, mobile website, or mobile application related or connected thereto.

## Information We Collect
- **Personal Information:** This includes information you provide during the intake process, such as your name, email address, age, and responses to our personality tests and questionnaires.
- **Usage Information:** We collect information about your interactions with our service, including the dates and times of access, features or pages viewed, and other similar information.
- **Technical Information:** Information about your computer, mobile device, or other device that you use to access our services, including IP address, operating system, browser type, and other software or hardware information.

## How We Use Your Information
- To provide, operate, and maintain our services
- To improve, personalize, and expand our services
- To understand and analyze how you use our services
- To develop new products, services, features, and functionality
- To communicate with you, either directly or through one of our partners, including for customer service, to provide you with updates and other information relating to the website, and for marketing and promotional purposes
- To process your transactions and manage coins
- To find and prevent fraud

## How We Share Your Information
We may share the information we have collected in certain circumstances, including:
- With service providers who perform services for us (we require all service providers to respect the security of your personal data and to treat it in accordance with the law).
- If we are involved in a merger, acquisition, or asset sale, your Personal Information may be transferred.
- For legal reasons, including to comply with legal process or to protect the rights, property, or safety of Wiser, our users, or the public.

## Security of Your Information
We use administrative, technical, and physical security measures to help protect your personal information. While we have taken reasonable steps to secure the personal information you provide to us, please be aware that despite our efforts, no security measures are perfect or impenetrable, and no method of data transmission can be guaranteed against any interception or other type of misuse.

## Your Data Protection Rights
Depending on your jurisdiction, you may have rights regarding your personal data, including:
- The right to access
- The right to correction
- The right to erasure
- The right to restrict processing
- The right to object to processing
- The right to data portability
- The right to withdraw consent

## Children's Privacy
Our services are not directed to individuals under the age of 18. We do not knowingly collect personal information from children under 18. If we become aware that a child under 18 has provided us with personal information, we will take steps to delete such information from our files.

## Changes to This Privacy Policy
We may update our Privacy Policy from time to time. We will notify you of any changes by posting the new Privacy Policy on this page. You are advised to review this Privacy Policy periodically for any changes.

## Contact Us
If you have any questions about this Privacy Policy, please contact us through our contact form.
`

export const privacyNl = `
## Pivacy verklaring
Bij Wiser zetten we ons in voor de bescherming van de privacy en veiligheid van de informatie van onze gebruikers. Dit Privacybeleid legt uit hoe we uw informatie verzamelen, gebruiken, openbaar maken en beschermen wanneer u onze website bezoekt, onze applicatie gebruikt of met onze diensten in contact komt, inclusief elke andere mediavorm, mediakanaal, mobiele website of mobiele applicatie die daarmee verbonden is.

## Informatie die we verzamelen
- **Persoonlijke Informatie:** Dit omvat informatie die u verstrekt tijdens het intakeproces, zoals uw naam, e-mailadres, leeftijd en reacties op onze persoonlijkheidstesten en vragenlijsten.
- **Gebruiksinformatie:** We verzamelen informatie over uw interacties met onze dienst, inclusief de data en tijden van toegang, bekeken functies of pagina's, en andere soortgelijke informatie.
- **Technische Informatie:** Informatie over uw computer, mobiele apparaat of ander apparaat dat u gebruikt om toegang te krijgen tot onze diensten, inclusief IP-adres, besturingssysteem, browsertype en andere software- of hardware-informatie.

## Hoe we uw informatie gebruiken
- Om onze diensten te leveren, te bedienen en te onderhouden
- Om onze diensten te verbeteren, te personaliseren en uit te breiden
- Om te begrijpen en te analyseren hoe u onze diensten gebruikt
- Om nieuwe producten, diensten, functies en functionaliteit te ontwikkelen
- Om met u te communiceren, direct of via een van onze partners, inclusief voor klantenservice, om u updates en andere informatie met betrekking tot de website te verstrekken, en voor marketing- en promotiedoeleinden
- Om uw transacties te verwerken en munten te beheren
- Om fraude op te sporen en te voorkomen

## Hoe we uw informatie delen
We kunnen de informatie die we hebben verzameld in bepaalde omstandigheden delen, inclusief:
- Met dienstverleners die diensten voor ons uitvoeren (we vereisen dat alle dienstverleners de veiligheid van uw persoonlijke gegevens respecteren en deze behandelen in overeenstemming met de wet).
- Als we betrokken zijn bij een fusie, overname of verkoop van activa, kan uw Persoonlijke Informatie worden overgedragen.
- Om juridische redenen, inclusief om te voldoen aan juridische procedures of om de rechten, eigendom of veiligheid van Wiser, onze gebruikers of het publiek te beschermen.

## Beveiliging van uw informatie
We gebruiken administratieve, technische en fysieke beveiligingsmaatregelen om uw persoonlijke informatie te helpen beschermen. Hoewel we redelijke stappen hebben ondernomen om de persoonlijke informatie die u ons verstrekt te beveiligen, wees u ervan bewust dat ondanks onze inspanningen, geen beveiligingsmaatregelen perfect of ondoordringbaar zijn, en geen enkele methode van gegevensoverdracht kan worden gegarandeerd tegen enige onderschepping of ander type misbruik.

## Uw gegevensbeschermingsrechten
Afhankelijk van uw rechtsgebied, kunt u rechten hebben met betrekking tot uw persoonlijke gegevens, inclusief:
- Het recht op toegang
- Het recht op correctie
- Het recht op verwijdering
- Het recht om verwerking te beperken
- Het recht om bezwaar te maken tegen verwerking
- Het recht op gegevensoverdraagbaarheid
- Het recht om toestemming in te trekken

## Privacy van kinderen
Onze diensten zijn niet gericht op personen onder de 18 jaar. We verzamelen niet bewust persoonlijke informatie van kinderen onder de 18. Als we ons bewust worden dat een kind onder de 18 ons heeft voorzien van persoonlijke informatie, zullen we stappen ondernemen om dergelijke informatie uit onze bestanden te verwijderen.

## Wijzigingen in dit Privacybeleid
We kunnen ons Privacybeleid van tijd tot tijd bijwerken. We zullen u op de hoogte brengen van eventuele wijzigingen door het nieuwe Privacybeleid op deze pagina te plaatsen. U wordt geadviseerd dit Privacybeleid periodiek te herzien op eventuele wijzigingen.

## Contacteer ons
Als u vragen heeft over dit Privacybeleid, neem dan contact met ons op via ons contactformulier.

`
